import { useContext, useEffect, useState } from 'react'
import DocketStatics from './DocketStatics';
import providerContext from '../../context/provider/providerContext';
import { useCorporateStats, useDocketStaticsDashboard, useDocketStatsByFTLDashboard } from '../../hooks/docket/statics';
import ChartComp from './Chards/Chart';
import ResizableBox from '../Common/ResizableBox';
import FTLStats from './FTLStats';
import CorpDocketStats from './CorpDocketStats';

export default function AdminDashboardPage({ user }) {
    const { currentProvider } = useContext(providerContext);
    const [enableApi, setAPI] = useState(false)
    const { docketStaticsData, isDocketStaticsLoading, handleStaticsParam } = useDocketStaticsDashboard('', enableApi);
    const { ftlStatsData, ftlStatsIsLoading, handleFtlStaticsParam } = useDocketStatsByFTLDashboard('', enableApi);
    // console.log(user)
    useEffect(() => {
        setAPI(true)
        handleStaticsParam(`?provider=${currentProvider?.id}`)
    }, [currentProvider])
    return (
        <div className="chartDesign">
            <div className="InerChart">
                {user?.permissions?.dockets?.view && !user?.roles?.includes('LC') && <ChartComp />}
            </div>
            <ResizableBox>
                <div className="row">



                    {docketStaticsData && !isDocketStaticsLoading &&
                        <div className='col-xl-12'>
                            {user?.permissions?.dockets?.view && <DocketStatics
                                data={docketStaticsData}
                                heading='Total Dockets'
                                provider={currentProvider}
                                docketStaticsData={docketStaticsData}
                                isDocketStaticsLoading={isDocketStaticsLoading}
                            />}
                        </div>
                    }

                    <div className='col-xl-12'>
                        {user?.permissions?.dockets?.view && !user?.roles?.includes('LC') &&
                            <DocketStatics
                                data={docketStaticsData?.today}
                                isToday={true}
                            />}
                    </div>

                </div>
            </ResizableBox>

            <div className='row'>

                <div className='col-md-3 col-12 mt-5'>
                    <div className='shadow py-3'>
                        {user?.permissions?.dockets?.view && !user?.roles?.includes('LC') && <FTLStats
                            heading='FTL Stats Report - [Meghbela + PMPL]'
                            data={ftlStatsData}
                            isLoading={ftlStatsIsLoading}
                            provider={currentProvider}
                        />}
                    </div>
                </div>
                <div className='col-md-6 col-12'>

                </div>
                <div className='col-md-3 col-12 mt-5'>
                    {user?.permissions?.dockets?.view && !user?.roles?.includes('LC') && <CorpDocketStats
                        heading='Corporate Dockets Stats'
                    // data={corpStatsData}
                    // isLoading={isLoadingCorpStats}
                    // handleCorpStatsParam={handleCorpStatsParam}
                    // provider={currentProvider}
                    />}
                </div>
            </div>
        </div>
    )
}
